import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from './client.js';

/** A project's Android app (APK) state. */
export interface Apk {
  status: 'none' | 'building' | 'ready' | 'failed';
  builtAt: string | null;
  /** Short-lived download link, present only when an APK is ready. */
  downloadUrl: string | null;
}

export function useApk(projectId: string) {
  return useQuery({
    queryKey: ['apk', projectId],
    queryFn: () => apiFetch<{ apk: Apk }>(`/projects/${projectId}/apk`).then((r) => r.apk),
    // Poll while a build is in progress so the download link appears on its own.
    refetchInterval: (query) => (query.state.data?.status === 'building' ? 5000 : false),
  });
}

export function useBuildApk(projectId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => apiFetch<{ apk: Apk }>(`/projects/${projectId}/apk`, { method: 'POST' }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['apk', projectId] }),
  });
}
